import { AnyAction } from 'redux';
import { ParticipantEnrollmentAppActions, ParticipantEnrollmentAppState, ParticipantEnrollmentSteps } from '../models/app-states';


const InitialState: ParticipantEnrollmentAppState = {
	currentStep: null,
	isEligible: true,
};


export const participantEnrollmentReducer = (state = InitialState, action: AnyAction): ParticipantEnrollmentAppState => {


	switch (action.type) {
		case ParticipantEnrollmentAppActions.SET_PARTICIPANT_ENROLLMENT_CURRENT_STEP:
			return {
				...state,
				currentStep: action.payload,
			};

		case ParticipantEnrollmentAppActions.SET_PARTICIPANT_ENROLLMENT_ELIGIBILITY:
			return {
				...state,
				isEligible: action.payload,
			};

		default: return state;
	}
};

export const setCurrentParticipantEnrollmentStep = (step: ParticipantEnrollmentSteps) => {
	return {
		type: ParticipantEnrollmentAppActions.SET_PARTICIPANT_ENROLLMENT_CURRENT_STEP,
		payload: step,
	};
};

export const setCurrentParticipantEligibility = (isEligible: boolean) => {
	return {
		type: ParticipantEnrollmentAppActions.SET_PARTICIPANT_ENROLLMENT_ELIGIBILITY,
		payload: isEligible,
	};
};
